import Login from "../Components/Home/Login";
import Dashboard from "../Components/Dashboard/Main";
import ShuttleTrips from "../Components/Trips/Trips";
import PrivateTrips from "../Components/PrivateDriver/PrivateTrips";
import Departments from "../Components/Departments/Departments";
import DriversData from "../Components/Live Tracking/DriversData";
import LittleStaff from "../Components/LittleStaff/Staff";
import AddDepartment from "../Components/Departments/AddDepartment";
import DriverData from "../Components/Live Tracking/DriversData";
import ShuttleStops from "../Components/Shuttle/Stops/Stops";
import EditDriver from "../Components/PrivateDriver/Drivers/EditDriver";
import ShuttleDrivers from "../Components/Shuttle/Drivers/EditDriver";
import ShiftCreation from "../Components/PrivateDriver/Create Shift/ShiftCreation";
import Shifts from "../Components/PrivateDriver/Shifts/Shifts";
import Staff from "../Components/Staff/Staff";
import Admins from "../Components/Admins/Admins";
import Trips from "../Components/CommonTrips/Trips";
import Support from "../Components/Support/Support";
import Routes from "../Components/Routes/Route";
import Stops from "../Components/Routes/Stops";
import DocumentsUpload from "../Components/Documents Upload/DocumentsUpload";
import DriverList from "../Components/Drivers/EditDriver";
import Booking from "../Components/ScheduleBooking/New Booking/NewBooking";
import ScheduleTrips from "../Components/ScheduleBooking/Trips/ScheduleTrips";
import PreviousBookings from "../Components/ScheduleBooking/Previous Bookings/PreviousBookings";
import BookingDetails from "../Components/ScheduleBooking/BookingDetails";
import Bookings from "../Components/Shuttle/Route Booking/Bookings";
import NewBooking from "../Components/Shuttle/Route Booking/NewBooking";
import QrCode from "../Components/PrivateDriver/Drivers/QrCode";
import Settings from "../Components/Settings/Settings";
import NewRegistration from "../Components/AddNewCorp/NewRegistration";
import AddPricingStructure from "../Components/PricingStructure/AddPricingStructure";
import AddNewTasks from "../Components/Settings/AddNewTasks";
import CorporateRecords from "../Components/Corporates/CorporateRecord";
import TestRouteInfo from "../Components/Routes/TestAddRoute/TestRouteInfo";
import StopInfo from "../Components/Routes/AddRoute/StopInfo";
import TestStopInfo from "../Components/Routes/TestAddRoute/TestStopInfo";
import TripDetails from "../Components/CommonTrips/TripDetails";
import DriverRegistration from "../Components/Drivers/DriverRegistration";
import DocumentMaster from "../Components/CommonComponent/DocumentMaster/DocumentMaster";
import VerificationDocuments from "../Components/Drivers/VerificationDocument";
import Vehicles from "../Components/Vechicles/Vehicles";
import VehicleVerification from "../Components/Vechicles/VehicleVerification";
import PartnerVerification from "../Components/Partners/PartnerVerification";
import Partners from "../Components/Partners/Partners";
import StudentApp from "../Components/StudentPortal/StudentApp";
import RegisterVehicle from "../Components/Vechicles/RegisterVehicle";
import Fuels from "../Components/Fuels/Fuels";
import Notifications from "../Components/Notifications/Notifications";
import SendNotification from "../Components/Notifications/SendNotification";
import LandingPage from "../LandingPG/LandingPage";

const authRoutes = [
  { path: "/dashboard", component: Dashboard },
  { path: "/shuttle/trips", component: ShuttleTrips },
  { path: "/privatedrive/trips", component: PrivateTrips },
  { path: "/live-tracking", component: DriversData },
  { path: "/little-staff", component: LittleStaff },
  { path: "/departments/add-new", component: AddDepartment },
  { path: "/departments", component: Departments },
  { path: "/privatedrive/livemap", component: DriverData },
  { path: "/shuttle/stops", component: ShuttleStops },
  { path: "/privatedrive/drivers", component: EditDriver },
  { path: "/shuttle/drivers", component: ShuttleDrivers },
  { path: "/privatedrive/shift-creation", component: ShiftCreation },
  { path: "/privatedrive/shifts", component: Shifts },
  { path: "/edit", component: AddDepartment },
  { path: "/staffs", component: Staff },
  { path: "/admins", component: Admins },
  { path: "/trips/:tripId", component: TripDetails },
  { path: "/trips", component: Trips },
  { path: "/support", component: Support },
  { path: "/routes", component: Routes },
  { path: "/routes/:routeId", component: Stops },
  { path: "/addroute", component: TestRouteInfo },
  { path: "/addroute-stop", component: TestStopInfo },
  { path: "/vehicles", component: Vehicles },

  { path: "/documents", component: DocumentMaster },
  { path: "/corporatedocument", component: DocumentsUpload },
  { path: "/schedule-booking/new booking", component: Booking },
  { path: "/schedule-booking/trips", component: ScheduleTrips },
  { path: "/schedule-booking/bookings", component: PreviousBookings },
  {
    path: "/schedule-booking/previous bookings/details",
    component: BookingDetails,
  },
  { path: "/shuttle/bookings", component: Bookings },
  { path: "/shuttle/new-booking", component: NewBooking },
  { path: "/drivers/:emailId", component: QrCode },
  { path: "/rider/:mobileNumber", component: QrCode },
  { path: "/drivers", component: DriverList },
  { path: "/settings", component: Settings },
  { path: "/fuels", component: Fuels },
  { path: "/new-registration", component: NewRegistration },
  { path: "/addpricing", component: AddPricingStructure },
  { path: "/corporates", component: CorporateRecords },
  { path: "/driver-registration", component: DriverRegistration },
  { path: "/verification-documents", component: VerificationDocuments },
  { path: "/verification-documents-vehicle", component: VehicleVerification },
  { path: "/verification-documents-partner", component: PartnerVerification },
  { path: "/partners", component: Partners },
  { path: "/vehicles", Vehicles },
  { path: "/new-vehicle", component: RegisterVehicle },
  { path: "/notifications", component: Notifications },
  { path: "/send-notification", component: SendNotification },
  // { path: "/support", component: Support },
];
const publicRoutes = [
  { path: "/login", component: Login },
  { path: "/home", component: LandingPage },
  { path: "/student-staff-registration", component: StudentApp },
];

// const superAdminRoutes=[{path: '/new-registration', component: NewRegistration}]

export { authRoutes, publicRoutes };
